import { render, staticRenderFns } from "./HomeBeneficiosView.vue?vue&type=template&id=17d8f1a2&scoped=true&"
import script from "./HomeBeneficiosView.vue?vue&type=script&lang=ts&"
export * from "./HomeBeneficiosView.vue?vue&type=script&lang=ts&"
import style0 from "./HomeBeneficiosView.vue?vue&type=style&index=0&id=17d8f1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d8f1a2",
  null
  
)

export default component.exports